import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";

type Props = {
  fileUrl?: string;
  showbyLineImage?: boolean;
  altText?: string;
  width?: string;
  height?: string;
  wrapperClassNames?: string;
};

const TeaserByLineImage = ({
  fileUrl,
  showbyLineImage,
  altText,
  width = "87px",
  height = "87px",
  wrapperClassNames,
}: Props) => {
  const isAutoHeight = height === "auto";

  return (
    <>
      {showbyLineImage && fileUrl && (
        <div
          style={isAutoHeight ? { width } : { width, height }}
          className={classNames(
            "absolute flex-shrink-0 right-0 bottom-0",
            isAutoHeight ? "top-0" : "",
            wrapperClassNames,
          )}
        >
          <Image
            src={createImageUrl(fileUrl, {})}
            alt={altText || ""}
            fill
            sizes={createImageSizes({
              mobile: "22vw",
              tablet: "22vw",
              desktop: "22vw",
            })}
            className="object-contain object-right-bottom"
          />
        </div>
      )}
    </>
  );
};

export default TeaserByLineImage;
